import { render, staticRenderFns } from "./WineryContact.vue?vue&type=template&id=049e2528&"
import script from "./WineryContact.vue?vue&type=script&lang=js&"
export * from "./WineryContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports